import React from 'react';
export const Footer = () => {
  return <footer className="bg-navy-950 py-8 md:py-12 border-t border-navy-800" data-id="element-114">
      <div className="container mx-auto px-4 text-center" data-id="element-115">
        <h2 className="text-2xl md:text-3xl font-bebas text-white mb-3 md:mb-4 text-glow-gold" data-id="element-116">
          ARMADOR DE ÉLITE™
        </h2>
        <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto mb-5 md:mb-8" data-id="element-117">
          El sistema de desarrollo N°1 para armadores de voleibol en Argentina.
          Porque dominar la posición más exigente del juego no debería costarte
          años de prueba y error sin dirección.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-8 text-xs md:text-sm text-gray-300 mb-6 md:mb-12" data-id="element-118">
          <a href="mailto:soporte.activadigitalok@gmail.com" className="hover:text-gold-500 transition-colors" data-id="element-119">
            soporte.activadigitalok@gmail.com
          </a>
          <span className="hidden md:block text-navy-700" data-id="element-120">|</span>
          <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-121">
            @activadigital.store
          </a>
          <span className="hidden md:block text-navy-700" data-id="element-122">|</span>
          <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-123">
            activadigital.store
          </a>
        </div>

        <div className="text-xs text-gray-600" data-id="element-124">
          © Activa Digital™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
};